/** Catchy homepage hooks — Farenodex / flights */
export const HOOKS_SECTION = {
  eyebrow: 'Why call instead of click?',
  title: 'Real deals. Real people. Right now.',
  subtitle: 'Skip the endless tabs — our agents find fares you won’t always see online.',
};

export const HOOKS = [
  {
    id: 'fare-drop',
    hook: 'Stop refreshing — we watch the fare drop for you.',
    tagline: 'Tell us your route; we alert you when prices dip.',
    icon: 'trending',
  },
  {
    id: 'beat-online',
    hook: 'Saw a price online? Call us — we often beat it.',
    tagline: 'Phone-only fares and partner rates not on every site.',
    icon: 'zap',
  },
  {
    id: 'five-min',
    hook: 'Book in under 5 minutes. Human. Not a bot.',
    tagline: 'Flights, hotels, cars & packages — one number.',
    icon: 'clock',
  },
  {
    id: 'not-sold-out',
    hook: "Your seat isn't 'gone' until we say so.",
    tagline: 'Waitlists, holds & alternate dates — we work every angle.',
    icon: 'shield',
  },
];
